// Optional client "frame" around the game content (e.g. cream card with red border
// and hard offset shadow) — grows with the content so it always contains it.
export const frameStyle = (f) => ({
  background: f.fill,
  border: `4px solid ${f.border}`,
  boxShadow: `10px 12px 0 ${f.shadow}`,
  borderRadius: 28,
});

export function ContentFrame({ frame, className = "", children }) {
  if (!frame) return children;
  return (
    <div className={`px-4 py-8 sm:px-10 sm:py-12 ${className}`} style={frameStyle(frame)} data-testid="game-content-frame">
      {children}
    </div>
  );
}
